import React from "react";
import { Form, Button, Select } from "antd";
import { ReactComponent as OutPutIcon } from "@/assets/icons/output.svg";
import { useTranslation } from "react-i18next";
import "@/assets/audioCompress.less";

const { Option } = Select;

const AudioCompressWorkOperationRender = ({ compressing, handleCompress, handleQuality, handleFormat }) => {
  const { t } = useTranslation(["audioCompress"]);
  return (
    <div className={`step-con ${compressing ? "disabled" : ""}`}>
      <div className="step-header">
        <span className="step-num active">
          <span>2</span>
        </span>
        <div className="step-item">
          <OutPutIcon />
          <span>{t("Output Settings")}</span>
        </div>
      </div>
      <div className="step-cont">
        <Form>
          <Form.Item label={t("Quality")}>
            <Select defaultValue="256" style={{ width: 160 }} onChange={handleQuality}>
              <Option value="320">320kbps</Option>
              <Option value="256">256kbps</Option>
              <Option value="128">128kbps</Option>
              <Option value="64">64kbps</Option>
              <Option value="32">32kbps</Option>
            </Select>
          </Form.Item>
          <Form.Item label={t("Format")}>
            <Select defaultValue="mp3" style={{ width: 160 }} onChange={handleFormat}>
              <Option value="wav">WAV</Option>
              <Option value="mp3">MP3</Option>
              <Option value="m4a">M4A</Option>
              <Option value="aac">AAC</Option>
              <Option value="ogg">OGG</Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={handleCompress}>
              {t("Compress")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AudioCompressWorkOperationRender;
